import { render, staticRenderFns } from "./PaymentMethodsInbound.vue?vue&type=template&id=248ce47e"
import script from "./PaymentMethodsInbound.vue?vue&type=script&lang=js"
export * from "./PaymentMethodsInbound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports